export default __webpack_public_path__ + "static/media/base-report11.93838afb.png";